(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-brand-orbit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tbs-brand-orbit'))customElements.define('tbs-brand-orbit',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.tbs-orbit__card')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion:reduce)').matches;this.hover=false;this.visible=false;this.abort=new AbortController();const signal=this.abort.signal;this.addEventListener('mouseenter',()=>this.hover=true,{signal});this.addEventListener('mouseleave',()=>this.hover=false,{signal});this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1,true)}},{signal});const stage=this.querySelector('.tbs-orbit__stage');stage.addEventListener('dragstart',e=>e.preventDefault(),{signal});stage.addEventListener('pointerdown',e=>{this.startX=e.clientX;this.startY=e.clientY;this.dragged=false;e.target.setPointerCapture(e.pointerId)},{signal});stage.addEventListener('pointerup',e=>{if(this.startX==null)return;const dx=e.clientX-this.startX,dy=e.clientY-this.startY;this.startX=null;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)){this.dragged=true;this.move(dx<0?1:-1,true)}},{signal});stage.addEventListener('pointercancel',()=>this.startX=null,{signal});stage.addEventListener('wheel',e=>{if(Math.abs(e.deltaX)>5||Math.abs(e.deltaY)>5){e.preventDefault();const now=Date.now();if(!this.lastWheel||now-this.lastWheel>650){this.lastWheel=now;this.move((Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:e.deltaY)>0?1:-1,true)}}},{signal,passive:false});this.cards.forEach((card,i)=>{card.addEventListener('click',e=>{if(this.dragged){e.preventDefault();this.dragged=false;return}if(i!==this.index){e.preventDefault();this.index=i;this.render(true)}},{signal});const img=card.querySelector('img');if(img)img.addEventListener('error',()=>{img.hidden=true;const word=document.createElement('strong');word.textContent=card.dataset.brand;img.replaceWith(word)},{once:true,signal})});this.observer=new IntersectionObserver(entries=>this.visible=entries[0].isIntersecting);this.observer.observe(this);this.render(false)}move(step,manual){this.index=(this.index+step+this.cards.length)%this.cards.length;this.render(manual)}render(manual){const n=this.cards.length;this.cards.forEach((card,i)=>{let d=(i-this.index+n)%n;if(d>n/2)d-=n;const a=Math.abs(d),shown=a<=2;card.style.transform=`translateX(calc(-50% + ${d} * var(--spread))) translateY(${a*22}px) rotate(${d*10}deg) scale(${1-a*.13})`;card.style.opacity=shown?String(1-a*.18):'0';card.style.zIndex=String(5-a);card.style.pointerEvents=shown?'auto':'none';card.setAttribute('aria-hidden',String(!shown));card.tabIndex=d===0?0:-1});if(manual)this.querySelector('.tbs-orbit__status').textContent=this.cards[this.index].dataset.brand}disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.ready=false}});

  } catch(e) { console.error(e); }
})();
})();
